import { render, staticRenderFns } from "./NotificationCart.vue?vue&type=template&id=2cdcf380&scoped=true&"
import script from "./NotificationCart.vue?vue&type=script&lang=js&"
export * from "./NotificationCart.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCart.vue?vue&type=style&index=0&id=2cdcf380&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdcf380",
  null
  
)

export default component.exports